import { type ReactNode, useMemo } from 'react';
import { useSnapshot } from 'valtio';
import Checkbox from '~/components2/forms/Checkbox';
import store from '../../../../store';
import { DrawerContainer, DrawerContent, DrawerFooter } from '../../../Drawer';
import { NextButton, PreviousButton } from '../../StepButtons';
import FeeConfirmation from './FeeConfirmation';
import Files from './Files';
import Links from './Links';

export default function AddDocuments() {
  const { constraints, formState, selectedAgencyIds, agencies } = useSnapshot(store);

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  const mapFeeTable = useMemo(() => {
    if (constraints.hasFeeConstraints) {
      const rows: ReactNode[] = [];
      selectedAgencyIds.forEach((agencyId) => {
        const a = agencies[agencyId];
        if (a.chargesMapFees) {
          rows.push(
            <tr key={agencyId}>
              <td>{a.agencyName}</td>
              <td>
                {a.mapFeeNote && (
                  <>
                    <span>{a.mapFeeNote}</span>
                    <br />
                  </>
                )}
                {a.averageMapFeePerPage ? (
                  <>
                    <br />
                    <div>
                      Based on past requests, average map fee per page is ${a.averageMapFeePerPage}. Requesting exact
                      cost from agency typically adds significant delays to requests.
                    </div>
                  </>
                ) : null}
              </td>
            </tr>,
          );
        }
      });

      return (
        <table>
          <thead>
            <th>Agency</th>
            <th>Note</th>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      );
    } else {
      return null;
    }
  }, [constraints.hasFeeConstraints]);

  return (
    <DrawerContainer>
      <DrawerContent>
        {constraints.hasFileConstraints && (
          <>
            <Links />
            <Files />
          </>
        )}

        <div className="w-full space-y-4">
          {constraints.hasFileConstraints && (
            <Checkbox
              data-testid="request-data-files-confirmed"
              isRequired
              label="I have submitted all the necessary documents and understand that any missing items may cause delays in processing my request."
              checked={formState.filesConfirmed}
              value={formState.filesConfirmed}
              onChange={(checked) => {
                store.formState.filesConfirmed = checked;
              }}
            />
          )}

          <FeeConfirmation />
        </div>
      </DrawerContent>

      <DrawerFooter>
        <PreviousButton onClick={() => store.toggleFormStep(-1)} />

        <NextButton disabled={!constraints.acknowledged} onClick={() => store.toggleFormStep(1)} />
      </DrawerFooter>
    </DrawerContainer>
  );
}
